import React from 'react'
import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'
import cx from 'classnames'

import { Card, CardTitle, CardText, Fade } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import './ImportResult.scss'

function ImportResult({ result }) {
    const classNames = cx('ao-importresults', { 'ao-importresult--failed': !result.isSuccess })

    const Failed = (
        <span title="Gefaald">
            <FontAwesomeIcon icon="times" /> {result.errorMessage}
        </span>
    )

    const Success = (
        <React.Fragment>
            <span title="Medewerkers verwerkt">
                <FontAwesomeIcon icon="users" /> {result.processed}
            </span>
            <span title="Verwerkingstijd">
                <FontAwesomeIcon icon="clock" /> {result.processTime}
            </span>
        </React.Fragment>
    )

    return (
        !isEmpty(result) && (
            <Fade>
                <Card body outline color={ result.isSuccess ? 'success' : 'danger' } className={ classNames }>
                    <CardTitle>{result.isSuccess ? 'Import succesvol' : 'Import gefaald'}</CardTitle>
                    <CardText className="ao-importresults__content">{result.isSuccess ? Success : Failed}</CardText>
                </Card>
            </Fade>
        )
    )
}

ImportResult.propTypes = {
    result: PropTypes.object
}

export default ImportResult
